import create from 'zustand'
import { persist } from 'zustand/middleware'
import axios from 'axios'
import jwtDecode from 'jwt-decode'

const centerOfGermanyGeoLocation = {
  lat: 51.34185087096748,
  lng: 10.454119349999985
}
const initialZoomLevel = 6
const initialMapSize = {
  width: 785, // Map width in pixels
  height: 600 // Map height in pixels
}

export const useStore = create(
  persist(
    set => ({
      marketDe: null,
      marketAt: null,
      searchLanguage: null,
      deleteMarket: () => {
        set(() => ({
          market: null
        }))
      }
    }),
    {
      name: 'market-storage'
    }
  )
)

export const useMarketSearchStore = create(set => ({
  markets: null,
  locationInput: '',
  isMapDisplayed: null,
  mapConsentUpdate: null,
  marketSearchToggled: null,
  suggestedMarkets: [],
  suggestedAddresses: [],
  showDropdown: false,
  mapState: {
    center: centerOfGermanyGeoLocation,
    zoom: initialZoomLevel,
    location: centerOfGermanyGeoLocation,
    size: initialMapSize,
    bounds: null
  },
  getToken: async () => {
    try {
      const res = await axios.get(process.env.GATSBY_API_MARKET_SEARCH_TOKEN)
      const { googleMapsApiKey } = jwtDecode(res.data.token)
      set({ token: res.data.token, googleMapsApiKey })
    } catch (err) {
      console.log(err, "can't get Token")
    }
  }
}))

export const useSearchStore = create(set => ({
  searchTerm: {
    offer: undefined,
    receipe: undefined,
    post: undefined
  },
  searchRadius: {
    offer: undefined,
    receipe: undefined,
    post: undefined
  },
  filters: {
    offer: {}
  },
  setSearchTerm: (index, updatedTerm) =>
    set(state => {
      state.searchTerm[index] = updatedTerm
    }),
  deleteSearchTerm: index =>
    set(state => {
      state.searchTerm[index] = undefined
    }),
  setSearchRadius: (index, updatedRadius) =>
    set(state => {
      state.searchRadius[index] = updatedRadius
    }),
  setFilters: (index, updatedFilters) =>
    set(state => {
      state.filters[index] = updatedFilters
    }),
  deleteFilters: index =>
    set(state => {
      state.filters[index] = {}
    })
}))
